import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import { type IGridCellRendererParams } from "commonComponents/utilities/AgGridReact/AgGridReact.types";
import { DateDisplayDate } from "commonComponents/utilities/DateDisplay/DateDisplayDate";

function columnDateTimeInternal(props: IGridCellRendererParams) {
    const value = props.value as string | number | Date | null | undefined;
    if (props.node.group || value == null) {
        return null;
    }
    return (
        <DateDisplayDate
            data-testid="ag-col-date-time"
            value={value instanceof Date ? value : new Date(value)}
            showTime
            className={cn("ag-col-date-time", props.className)}
        />
    );
}

export const columnDateTime = memo(columnDateTimeInternal);
